<template>
    <ul class="search-results__list">
        <slot />
    </ul>
</template>

<script setup></script>

<style scoped>
.search-results__list {
    @apply flex flex-col gap-y-1 max-h-80 overflow-y-auto;
}

.search-results__list::-webkit-scrollbar {
    @apply w-1;
}

.search-results__list::-webkit-scrollbar-thumb {
    @apply rounded-xl bg-[--text-gray];
}
</style>
